import React from 'react';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';

export type HelpMeAlertProps = {
    status: 'success' | 'warning' | 'error' | 'info';
    title?: string;
    children: React.ReactNode;
    'data-testid'?: string;
};

// A constant margin plus a max-width is enough on its own - Layout.Stack already centers this
// div based on its own content width, so there's no need to separately widen the margin at
// larger viewports; the max-width caps it there instead.
const AlertContainer = styled('div', {
    margin: '0 1.25rem',
    maxWidth: '42.5rem',
});

// Uniform wrapper for every Alert used across the HelpMe site: always inline (contained,
// card-style - not a full-width banner), contained to a comfortable reading width, and never
// user-dismissible. Wrapped in Layout.Stack to match the same compositional pattern
// LockStatus.tsx (and every page's own root) already uses to center/contain a block. Only
// exposes the props call sites actually vary; see Alert's own AlertProps for the full surface
// if more are needed later.
export const HelpMeAlert = ({ status, title, children, ...rest }: HelpMeAlertProps) => {
    return (
        <Layout.Stack alignLayout="center">
            <AlertContainer>
                <Alert inline status={status} title={title} dismissible={false} {...rest}>
                    {children}
                </Alert>
            </AlertContainer>
        </Layout.Stack>
    );
};
